<template>
  <tr>
     <td>
        <div class="bg-primary w-45px h-45px d-flex justify-content-center align-items-center item-number">
            <button :title="getPhone" class="bg-primary item-number w-45px h-45px" @click.stop="getPhoneCard">
               {{num}}
            </button>
        </div>
     </td>
     <td>{{name}}</td>
     <td>{{start}}</td>
     <td>{{end}}</td>
     <td>
        <div class="d-flex flex-column justify-content-center align-items-center">       
            <button type="submit"  title="Tiempo restante, da clic para finalizar" class="colored-bg fa-xs" :class="bgColorClass"
               @click.stop="closeRent">
               {{timeRemaining}}
            </button>
        </div>
     </td>
     <td>
        <div class="d-flex flex-column justify-content-center align-items-center">  
            <a class="cursor-brink-pointer font-20" @click.stop="addTimeToRent"><i class="fas fa-clock" title="Adicionar tiempo"></i></a>
            <a class="text-brink-danger cursor-brink-pointer font-20" @click.stop="incidentToRent"><i class="fas fa-radiation-alt" title="Incidencia"></i></a>    
        </div>
     </td>
  </tr>
</template>

<script>
export default {
   name: "TimeTableRow",
   props: {
      num: [String, Number],
      name: String,
      start: String,
      end: String,
      remaining: Number,
      rent_id: Number,
      phone: String
   },
   computed: {
      bgColorClass(){
         // Aplica banderas de color solo para tiempos normales
         if(this.end !== undefined){
            if(this.remaining <= 2){
               return "danger"
            }
            else if(this.remaining > 2 && this.remaining < 5) {
               return "warning"
            }
            else {
               return "idle"
            }
         }else{
            return "freeTime"
         }
      },
      timeRemaining(){
         if((this.remaining + "") === 0){
            return "Finalizar"
         }else{
            return this.remaining + " min."
         }
      },
      getPhone(){
         let phone_number = ''
         if(this.phone !== undefined){
            phone_number = this.phone
         }
         return phone_number
      }
   },
   methods: {
      async closeRent(){
         await this.$emit('on-closeRent-action', this.rent_id);
      },
      async addTimeToRent(){
         await this.$emit('on-addTime-action', this.rent_id);
      },
      async incidentToRent(){
         await this.$emit('on-incident-action', this.rent_id);
      },
      getPhoneCard(){
         let phone_number = ''
         if(this.phone !== undefined){
            phone_number = this.phone
         }
         const txt = 'TELÉFONO REGISTRADO: ' + phone_number
         this.successNotifDialog("DATOS DEL CLIENTE", txt)
         // Confirmación de eliminación de tarjeta		
         this.confirmationDialogInfo(this.doPrintTicket, "Información", txt, "Reimprimir ticket");
      },
      async doPrintTicket(){
         await this.$emit('on-printTicket-action', this.rent_id);
      }
   },

}
</script>

<style>

</style>
